import { getCurrentInstance } from 'vue';

export function useUid(): number {
  const instance = getCurrentInstance();
  if (!instance) {
    throw new Error('useUid() must be called within setup()');
  }
  return instance.uid;
}
